import { Navigate } from "react-router-dom";

// /about → redirect to the Team subpage by default
export default function About() {
  return <Navigate to="/about/team" replace />;
}
